(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  // Wire visual header slider buttons to the hidden functional buttons inside slider-component.
  // Also sync the disabled attribute so circle buttons reflect start/end state.
  (function () {
    function initHeaderSlider(sliderId) {
      var headerButtons = document.querySelectorAll('[data-slider-target="' + sliderId + '"]');
      var functionalWrap = document.querySelector('[data-slider-functional="' + sliderId + '"]');
      if (!headerButtons.length || !functionalWrap) return;

      var funcPrev = functionalWrap.querySelector('button[name="previous"]');
      var funcNext = functionalWrap.querySelector('button[name="next"]');
      if (!funcPrev || !funcNext) return;

      headerButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.dataset.sliderAction === 'previous') {
            funcPrev.click();
          } else {
            funcNext.click();
          }
        });
      });

      // Keep disabled state in sync
      var observer = new MutationObserver(function () {
        headerButtons.forEach(function (btn) {
          var target = btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext;
          if (target.disabled) {
            btn.setAttribute('disabled', 'disabled');
          } else {
            btn.removeAttribute('disabled');
          }
        });
      });
      observer.observe(funcPrev, { attributes: true, attributeFilter: ['disabled'] });
      observer.observe(funcNext, { attributes: true, attributeFilter: ['disabled'] });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-slider-header]').forEach(function (el) {
        initHeaderSlider(el.dataset.sliderHeader);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tarot"]) return;
  try {
    
  (function () {
    var accordion = document.getElementById('TarotAccordion');
    if (!accordion) return;

    var items = accordion.querySelectorAll('.tarot-card');

    items.forEach(function (details) {
      var body = details.querySelector('.tarot-card__body');

      details.addEventListener('toggle', function () {
        if (details.open) {
          body.style.maxHeight = body.scrollHeight + 'px';
        } else {
          body.style.maxHeight = '0';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wireSliderHeader(sliderId) {
      var headerButtons = document.querySelectorAll('[data-slider-target="' + sliderId + '"]');
      var functionalWrap = document.querySelector('[data-slider-functional="' + sliderId + '"]');
      if (!headerButtons.length || !functionalWrap) return;
      var funcPrev = functionalWrap.querySelector('button[name="previous"]');
      var funcNext = functionalWrap.querySelector('button[name="next"]');
      if (!funcPrev || !funcNext) return;
      headerButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.dataset.sliderAction === 'previous') funcPrev.click();
          else funcNext.click();
        });
      });
      new MutationObserver(function () {
        headerButtons.forEach(function (btn) {
          var target = btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext;
          if (target.disabled) btn.setAttribute('disabled', 'disabled');
          else btn.removeAttribute('disabled');
        });
      }).observe(funcPrev, { attributes: true, attributeFilter: ['disabled'] });
      new MutationObserver(function () {
        headerButtons.forEach(function (btn) {
          var target = btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext;
          if (target.disabled) btn.setAttribute('disabled', 'disabled');
          else btn.removeAttribute('disabled');
        });
      }).observe(funcNext, { attributes: true, attributeFilter: ['disabled'] });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-slider-header]').forEach(function (el) {
        wireSliderHeader(el.dataset.sliderHeader);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends HTMLElement {
      static STORAGE_KEY = 'sixnine_recently_viewed';
      static MAX_ITEMS = 16;

      connectedCallback() {
        this.sectionEl = document.querySelector('[data-recently-viewed-section="' + this.dataset.sectionId + '"]');
        this.ul = this.querySelector('[id^="Slider-"]');
        this.sliderComp = this.querySelector('slider-component');
        this.limit = parseInt(this.dataset.limit) || 4;

        this.saveCurrentProduct();

        const handles = this.getStoredHandles().filter(
          (h) => h !== this.dataset.currentHandle
        ).slice(0, this.limit);

        if (!handles.length) return;

        Promise.all(
          handles.map((h) =>
            fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null)
          )
        ).then((products) => {
          const valid = products.filter(Boolean);
          if (!valid.length) return;
          this.renderProducts(valid);
        });
      }

      saveCurrentProduct() {
        const handle = this.dataset.currentHandle;
        if (!handle) return;
        const stored = this.getStoredHandles();
        const updated = [handle, ...stored.filter((h) => h !== handle)].slice(
          0,
          RecentlyViewedProducts.MAX_ITEMS
        );
        try {
          localStorage.setItem(RecentlyViewedProducts.STORAGE_KEY, JSON.stringify(updated));
        } catch (_) {}
      }

      getStoredHandles() {
        try {
          return JSON.parse(localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY) || '[]');
        } catch (_) {
          return [];
        }
      }

      renderProducts(products) {
        if (!this.ul) return;
        this.ul.innerHTML = products
          .map((product, i) => this.cardHTML(product, i))
          .join('');

        requestAnimationFrame(() => {
          if (this.sliderComp && typeof this.sliderComp.resetPages === 'function') {
            this.sliderComp.resetPages();
          }
          this.wireHeaderSlider();
          if (this.sectionEl) this.sectionEl.removeAttribute('hidden');
        });
      }

      wireHeaderSlider() {
        const sliderId = 'rv-' + this.dataset.sectionId;
        const section = this.sectionEl;
        if (!section) return;

        const headerBtns = section.querySelectorAll('[data-slider-target="' + sliderId + '"]');
        const functionalWrap = this.querySelector('[data-slider-functional="' + sliderId + '"]');
        if (!headerBtns.length || !functionalWrap) return;

        const funcPrev = functionalWrap.querySelector('button[name="previous"]');
        const funcNext = functionalWrap.querySelector('button[name="next"]');
        if (!funcPrev || !funcNext) return;

        headerBtns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            (btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext).click();
          });
        });

        const syncDisabled = () => {
          headerBtns.forEach((btn) => {
            const target = btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext;
            if (target.disabled) btn.setAttribute('disabled', 'disabled');
            else btn.removeAttribute('disabled');
          });
        };

        new MutationObserver(syncDisabled).observe(funcPrev, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
        new MutationObserver(syncDisabled).observe(funcNext, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
      }

      cardHTML(product, index) {
        const variant = product.variants && product.variants[0];
        const price = variant ? variant.price : product.price;
        const compareAtPrice = variant ? variant.compare_at_price : product.compare_at_price;
        const hasDiscount = compareAtPrice && compareAtPrice > price;
        const imgSrc = product.featured_image || (product.images && product.images[0]);

        const displayTags = ['hot', 'new', 'sale'];
        const productTags = (product.tags || []).map(function(t) { return t.toLowerCase(); });
        const matchedTags = productTags.filter(function(t) { return displayTags.indexOf(t) !== -1; });
        const badgeHTML = matchedTags.length
          ? '<div class="card-product__tags" aria-hidden="true">' +
              matchedTags.map(function(t) {
                return '<span class="card-product__tag" data-tag="' + t + '">' + t.slice(0, 4).toUpperCase() + '</span>';
              }).join('') +
            '</div>'
          : '';

        const imgHTML = imgSrc
          ? '<img src="' + imgSrc + '" alt="' + this.esc(product.title) + '" loading="lazy" width="533" height="666" class="motion-reduce" style="width:100%;height:100%;object-fit:cover;">'
          : '';

        const oldPriceHTML = hasDiscount
          ? '<span class="price-item price-item--regular"><s>' + this.money(compareAtPrice) + '</s></span>'
          : '';

        const priceHTML = '<span class="price-item price-item--sale price-item--last">' + this.money(price) | money_with_currency +  '</span>';

        return (
          '<li id="Slide-rv-' + this.dataset.sectionId + '-' + index + '" class="grid__item slider__slide">' +
            '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
              '<div class="card card--standard card--media">' +
                '<div class="card__inner ratio" style="--ratio-percent:125%;">' +
                  '<div class="card__media">' +
                    '<div class="media media--transparent">' +
                      '<a href="/products/' + product.handle + '" tabindex="-1">' +
                        imgHTML +
                      '</a>' +
                    '</div>' +
                    badgeHTML +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="card-information">' +
                '<div class="card-information__wrapper">' +
                  '<h3 class="card__heading h5">' +
                    '<a href="/products/' + product.handle + '" class="full-unstyled-link">' +
                      this.esc(product.title) +
                    '</a>' +
                  '</h3>' +
                  '<div class="price">' +
                    '<div class="price__container">' +
                      oldPriceHTML +
                      priceHTML +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</li>'
        );
      }

      money(cents) {
        if (!cents && cents !== 0) return '';
        const format = this.dataset.moneyFormat || '{{amount}}';
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, format);
        }
        return (cents / 100).toFixed(2);
      }

      esc(str) {
        return String(str)
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      }
    }

    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  // Wire visual header slider buttons for product-recommendations (supports post-AJAX load).
  (function () {
    function wireRecommendedSlider(root, sliderId) {
      var headerButtons = root.querySelectorAll('[data-slider-target="' + sliderId + '"]');
      var functionalWrap = root.querySelector('[data-slider-functional="' + sliderId + '"]');
      if (!headerButtons.length || !functionalWrap) return;
      var funcPrev = functionalWrap.querySelector('button[name="previous"]');
      var funcNext = functionalWrap.querySelector('button[name="next"]');
      if (!funcPrev || !funcNext) return;
      headerButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.dataset.sliderAction === 'previous') funcPrev.click();
          else funcNext.click();
        });
      });
      new MutationObserver(function () {
        headerButtons.forEach(function (btn) {
          var target = btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext;
          if (target.disabled) btn.setAttribute('disabled', 'disabled');
          else btn.removeAttribute('disabled');
        });
      }).observe(funcPrev, { attributes: true, attributeFilter: ['disabled'] });
      new MutationObserver(function () {
        headerButtons.forEach(function (btn) {
          var target = btn.dataset.sliderAction === 'previous' ? funcPrev : funcNext;
          if (target.disabled) btn.setAttribute('disabled', 'disabled');
          else btn.removeAttribute('disabled');
        });
      }).observe(funcNext, { attributes: true, attributeFilter: ['disabled'] });
    }

    function initProductRecommendationsSlider(pr) {
      pr.querySelectorAll('[data-slider-header]').forEach(function (el) {
        wireRecommendedSlider(pr, el.dataset.sliderHeader);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('product-recommendations').forEach(function (pr) {
        // Wire on load (pre-AJAX state)
        initProductRecommendationsSlider(pr);
        // Wire after AJAX replaces innerHTML
        new MutationObserver(function () {
          initProductRecommendationsSlider(pr);
        }).observe(pr, { childList: true });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
